import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100% - 70px);
`;
